import { ColorType } from 'lightweight-charts';
import { themeColors } from '../../styles/theme.ts';

interface ThemedChartOptionsConfig {
  width: number;
  height: number;
  timeVisible?: boolean;
  rightOffset?: number;
  rightOffsetPixels?: number;
  shiftVisibleRangeOnNewBar?: boolean;
  includePaneSeparators?: boolean;
}

export const buildThemedChartOptions = ({
  width,
  height,
  timeVisible = true,
  rightOffset,
  rightOffsetPixels,
  shiftVisibleRangeOnNewBar,
  includePaneSeparators = false,
}: ThemedChartOptionsConfig) => ({
  layout: {
    background: { type: ColorType.Solid, color: themeColors.surface3 },
    textColor: themeColors.muted,
    ...(includePaneSeparators
      ? {
        panes: {
          separatorColor: themeColors.linePane,
          separatorHoverColor: themeColors.surfaceHover,
        },
      }
      : {}),
  },
  grid: {
    vertLines: { color: themeColors.lineChartVert },
    horzLines: { color: themeColors.lineChartHorz },
  },
  width,
  height,
  rightPriceScale: { borderColor: themeColors.lineStrong },
  timeScale: {
    timeVisible,
    secondsVisible: false,
    borderColor: themeColors.lineStrong,
    ...(rightOffset === undefined ? {} : { rightOffset }),
    ...(rightOffsetPixels === undefined ? {} : { rightOffsetPixels }),
    ...(shiftVisibleRangeOnNewBar === undefined ? {} : { shiftVisibleRangeOnNewBar }),
  },
  crosshair: {
    vertLine: { color: themeColors.mutedDark, width: 1 as const, style: 3 as const },
    horzLine: { color: themeColors.mutedDark, width: 1 as const, style: 3 as const },
  },
});
